import Swiper, { Navigation, Pagination, Thumbs } from "swiper";
import GallerySimple from "../blocks/gallery-simple";
import Gallery from "../blocks/gallery";
import GalleryVideo from "../blocks/gallery-video";

const Home = {
  init() {
    Home.shopSlider();
    Home.gridRowSlider();

    new GallerySimple(".gallery-simple");
    new Gallery(".gallery");
    new GalleryVideo(".gallery-video");
  },

  heroFancySlider() {
    const heroEl = $(".amro-hero");
    if (heroEl.length) {
      new Swiper(heroEl.find(".amro-hero__slider")[0], {
        modules: [Navigation],
        spaceBetween: -40,
        slidesPerView: 2,
        centeredSlides: true,
        loop: true,
        navigation: {
          prevEl: heroEl.find(".swiper-button-prev")[0],
          nextEl: heroEl.find(".swiper-button-next")[0],
        },
        breakpoints: {
          600: {
            slidesPerView: 3,
            spaceBetween: -20,
          },
        },
      });
    }
  },

  catSlider() {
    $(".amro-cat-slider").each(function () {
      const swiperEl = $(this);
      new Swiper(swiperEl.find(".swiper")[0], {
        modules: [Navigation],
        spaceBetween: 32,
        slidesPerView: 1.2,
        loop: true,
        navigation: {
          prevEl: swiperEl.find(".swiper-button-prev")[0],
          nextEl: swiperEl.find(".swiper-button-next")[0],
        },
        breakpoints: {
          600: {
            slidesPerView: 1.8,
          },
        },
      });
    });
  },

  testimonialSlider() {
    $(".amro-testi").each(function () {
      const testiEl = $(this);
      new Swiper(testiEl.find(".swiper")[0], {
        modules: [Navigation],
        spaceBetween: 20,
        slidesPerView: 1,
        loop: true,
        navigation: {
          prevEl: testiEl.find(".swiper-button-prev")[0],
          nextEl: testiEl.find(".swiper-button-next")[0],
        },
      });
    });
  },

  compareSlider() {
    const compareEl = $(".amro-compare");
    if (compareEl.length) {
      const slidesCount = compareEl.find(".swiper-slide").length;
      const isDesktop = window.innerWidth >= 900;

      const showNavigation = !(isDesktop && slidesCount <= 3);

      const prevButton = compareEl.find(".swiper-button-prev")[0];
      const nextButton = compareEl.find(".swiper-button-next")[0];

      if (prevButton && nextButton) {
        prevButton.style.display = showNavigation ? "" : "none";
        nextButton.style.display = showNavigation ? "" : "none";
      }

      new Swiper(compareEl.find(".swiper")[0], {
        modules: [Navigation],
        spaceBetween: 8,
        slidesPerView: "auto",
        centeredSlides: true,
        initialSlide: 1,
        navigation: {
          prevEl: prevButton,
          nextEl: nextButton,
        },

        breakpoints: {
          900: {
            spaceBetween: 32,
          },
          600: {
            spaceBetween: 16,
          },
        },
      });
    }
  },

  articleSlider() {
    const swiperEl = $(".amro-article-slider");
    if (swiperEl.length) {
      new Swiper(swiperEl.find(".swiper")[0], {
        modules: [Navigation],
        spaceBetween: 32,
        slidesPerView: 1.2,
        loop: true,
        navigation: {
          prevEl: swiperEl.find(".swiper-button-prev")[0],
          nextEl: swiperEl.find(".swiper-button-next")[0],
        },
        breakpoints: {
          600: {
            slidesPerView: 1.8,
          },
        },
      });
    }
  },

  showcaseSlider() {
    const showcaseEls = $(".amro-showcase");

    if (!showcaseEls.length) return;

    showcaseEls.each(function () {
      const showcaseEl = $(this);

      const thumbsEl = showcaseEl.find("[data-amro-showcase-thumbs]")[0];
      const mainEl = showcaseEl.find("[data-amro-showcase-main]")[0];
      const prevEl = showcaseEl.find(".swiper-button-prev")[0];
      const nextEl = showcaseEl.find(".swiper-button-next")[0];

      if (!thumbsEl || !mainEl) return;

      const thumbsSlider = new Swiper(thumbsEl, {
        slidesPerView: "auto",
        spaceBetween: 4,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        allowTouchMove: true,
        breakpoints: {
          0: {
            direction: "horizontal",
            slidesPerView: "auto",
            allowTouchMove: true,
          },
          900: {
            direction: "vertical",
            allowTouchMove: false,
          },
        },
      });

      new Swiper(mainEl, {
        modules: [Navigation, Thumbs],
        slidesPerView: 1,
        spaceBetween: 16,
        autoHeight: true,
        thumbs: {
          swiper: thumbsSlider,
        },
        navigation: {
          prevEl,
          nextEl,
        },
        on: {
          init: function () {
            if (window.innerWidth < 900) {
              thumbsSlider.slideTo(this.activeIndex);
            }
          },
          slideChange: function () {
            stopAllVideos(this);

            if (window.innerWidth < 900) {
              thumbsSlider.slideTo(this.activeIndex);
            }
          },
        },
      });
    });

    function stopAllVideos(swiper) {
      const slides = swiper.slides;

      slides.forEach((slide) => {
        const iframe = slide.querySelector("iframe");

        if (iframe) {
          const src = iframe.src;
          iframe.src = src; // reset → stops video
        }
      });
    }
  },

  shopSlider() {
    const shopEl = $(".shop");
    if (shopEl.length) {
      new Swiper(shopEl.find(".shop-slider")[0], {
        modules: [Pagination, Navigation],
        slidesPerView: "auto",
        spaceBetween: 20,

        pagination: {
          el: shopEl.find(".swiper-pagination")[0],
          bulletElement: "button",
          clickable: true,
        },
        navigation: {
          prevEl: shopEl.find(".swiper-button-prev")[0],
          nextEl: shopEl.find(".swiper-button-next")[0],
        },
        breakpoints: {
          1200: {
            slidesPerGroup: 4,
          },
        },
      });
    }
  },

  gridRowSlider() {
    const gridEls = $(".grid-row__slider");
    if (gridEls.length) {
      gridEls.each(function () {
        const gridEl = $(this);

        new Swiper(gridEl.find(".swiper")[0], {
          modules: [Navigation],
          slidesPerView: "auto",
          spaceBetween: 15,

          navigation: {
            prevEl: gridEl.find(".swiper-button-prev")[0],
            nextEl: gridEl.find(".swiper-button-next")[0],
          },
          breakpoints: {
            900: {
              spaceBetween: 20,
            },
          },
        });
      });
    }
  },
};

export default Home;
